module.exports = __webpack_public_path__ + "media/images/lb/965-f18153978fdb866afff79dee698053a9.svg";